export default __webpack_public_path__ + "static/media/incoming-call.aaaf0cb6.svg";